import type { SimulationSetupData, SimulationServiceVersion } from '~/store/simulation/types';
import { DEFAULT_SIMULATION_SERVICE_VERSION } from '~/store/simulation/types';

// Stamp is set once at create-time; an absent stamp resolves to DEFAULT_SIMULATION_SERVICE_VERSION.
export function resolveSimulationServiceVersion(setupData: SimulationSetupData | undefined): SimulationServiceVersion {
  return setupData?.serviceVersion === 'v1' ? 'v1' : DEFAULT_SIMULATION_SERVICE_VERSION;
}
